export * from './lib/info-banner-feature-shell.module';
